// Função para formatar o número do cartão
export const formatCardNumber = (number) => {
    // Aplica a separação enquanto o usuário digita, e não somente quando o número
    // já está completo. O mesmo utilitário é usado por Celcoin e Asaas.
    return String(number || '')
        .replace(/\D/g, '')
        .slice(0, 16)
        .replace(/(\d{4})(?=\d)/g, '$1 ');
};

// Formata a validade do cartão digitada em texto livre para "MM/AA" (padrão
// impresso no próprio cartão), inserindo a barra automaticamente enquanto o
// usuário digita. Limita a 4 dígitos (mês + ano com 2 dígitos).
export const formatCardExpiry = (value) => {
    const digitsOnly = String(value || '').replace(/\D/g, '').slice(0, 4);

    if (digitsOnly.length <= 2) {
        return digitsOnly;
    }

    return `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`;
};

// Extrai mês (1-12) e ano com 4 dígitos a partir do texto "MM/AA" digitado.
// Retorna null enquanto a validade ainda não foi completamente digitada.
export const parseCardExpiry = (formattedValue) => {
    const digitsOnly = String(formattedValue || '').replace(/\D/g, '');

    if (digitsOnly.length < 4) {
        return null;
    }

    const month = parseInt(digitsOnly.slice(0, 2), 10);
    // Assume sempre o século 2000: suficiente para qualquer cartão válido.
    const year = 2000 + parseInt(digitsOnly.slice(2, 4), 10);

    return { month, year };
};

// Valida se a validade extraída corresponde a um mês real (1-12) e a uma data
// futura (ou o mês corrente), evitando enviar ao provedor um cartão já vencido.
export const isCardExpiryValid = (expiry) => {
    if (!expiry || expiry.month < 1 || expiry.month > 12) {
        return false;
    }

    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    if (expiry.year < currentYear) {
        return false;
    }

    return !(expiry.year === currentYear && expiry.month < currentMonth);
};
